import { AuthProviderFactory } from './AuthProviderFactory';

export class AuthProvider {
    constructor() {
        this.authProviderFactory = new AuthProviderFactory();
        this.authProvider = this.authProviderFactory.build(null);
    }

    initProvider = async (authConfig) => {
        this.authProvider = this.authProviderFactory.build(authConfig);
        await this.authProvider.initialize();
    };

    login = (language) => this.authProvider.login(language);

    silentAuthentication = (callback) => this.authProvider.silentAuthentication(callback);

    otcAuthentication = (code, userName) => this.authProvider.otcAuthentication(code, userName);

    passUserName = (userName) => this.authProvider.passUserName(userName);

    handleAuthentication = async (callback) => this.authProvider.handleAuthentication(callback);

    logout = () => this.authProvider.logout();

    getAccessToken = async () => await this.authProvider.getAccessToken();

    getProfile = () => this.authProvider.getProfile();

    getTokenTimeToLive = () => this.authProvider.getTokenTimeToLive();

    isAuthenticated = () =>  this.authProvider.isAuthenticated();
    
    isRegularAuthentication = (authenticationType) => this.authProvider.isRegularAuthentication(authenticationType);
}

const auth = new AuthProvider();
export default auth;

